// src/components/shared/footer/Footer.jsx

//react hooks
import { Outlet, useNavigate } from "react-router-dom";
import { useMediaQuery } from "react-responsive";

//components
import FooterNavButton from "./footerNavButton";
import CustomModal from "../../shared/customModal/customModal";

// custom hooks
import { useIsStandalone } from "../../../hooks/useIsStandalone";
import { useLogoutModal } from "../../../hooks/useLogoutModal";
import { useAdminMode } from "../../../hooks/useAdminMode";
import { useUserMenuItems, useAdminMenuItems } from "../../../utils/getMenuItems";

//styles and images
import { Button, Div, ExitLink, FooterDivMain } from "../../../styles/styles";
import exit from "../../../images/exit_icon.svg";
import { useTranslation } from "react-i18next";
import { useEffect } from "react";
import { ensureNamespaces } from "../../../i18n";

const Footer = () => {

  const navigate = useNavigate();
  const isStandalone = useIsStandalone();
  const isDesktop = useMediaQuery({ minWidth: 821 });
  const isMobile = useMediaQuery({ maxWidth: 480 });

  const { t } = useTranslation('menu');
  
  useEffect(() => { ensureNamespaces(['menu']); }, []);

  // hook for changing admin-user mode
  const { adminMode, toggleAdmin, disableAdmin, isAdmin, loading } = useAdminMode();

  const { open, openModal, closeModal, confirmLogout } = useLogoutModal();

  // menu items from custom hooks
  const userItems = useUserMenuItems();
  const adminItems = useAdminMenuItems();


  const sourceItems = (isAdmin && adminMode ? adminItems : userItems) || [];

  // сравниваем по ссылке — так же, как раньше
  const isAdminMenuNow = isAdmin && adminMode && sourceItems === adminItems;

  const visibleItems = sourceItems
    .filter(item => !(isDesktop && item.hiddenOnDesktop))
    .filter(item => !(!isDesktop && (item.hiddenOnMobile || item.desktopOnly)));

  const toggleLabel = adminMode ? "Back to App" : "Admin";

  const handleToggle = () => {
    if (!isAdmin || loading) return;
    if (adminMode) {
      // disable admin mode
      disableAdmin();
      navigate("/"); 
    } else {
      // enable admin mode
      toggleAdmin();
      navigate("/admin/users");
    }
  };

  return (
    <>
      <FooterDivMain justifySpace>
        <Div
          
          row={!isDesktop}
          gap={isMobile || isDesktop ? "10px" : "30px"}
          
          mobileJustifySpaceEvenly={!isDesktop && !adminMode}
          pwa={isStandalone}
          style={{paddingBottom: isStandalone && "15px"}}
          height="auto"
        >
          {/* admin switcher on desktop */}
          {isAdmin && isDesktop && (
            <Button
              type="button"
              onClick={handleToggle}
              width="auto"
              decoration="underline"
            >
              {toggleLabel}
            </Button>
          )}

          {visibleItems.map(({ path, label, icon, activeIcon, isCentral }) => (
            <FooterNavButton
              key={path}
              to={path}
              label={label} // 
              icon={typeof icon === "string" ? icon : isDesktop ? icon.desktop : icon.mobile}
              activeIcon={typeof activeIcon === "string" ? activeIcon : isDesktop ? activeIcon.desktop : activeIcon.mobile}
              isCentral={!isDesktop && isCentral}
              // если из админ-режима кликаем по обычному пункту — выключим режим
              onClick={!isAdminMenuNow && adminMode ? () => disableAdmin() : undefined}
            />
          ))}
        </Div>

        {isDesktop && (
          <ExitLink onClick={openModal}>
            <img src={exit} alt="" />
            {t('other.exit')}
          </ExitLink>
        )}
      </FooterDivMain>

      <CustomModal open={open} onClose={closeModal} title={t('other.confirmTitle')}>
        <Div gap="15px" row>
          <Button onClick={confirmLogout} greenButton fontSize="14px" width="auto">
            {t('other.logoutConfirm')}
          </Button>
        </Div>
      </CustomModal>

      <Outlet />
    </>
  );
};

export default Footer;
